import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';

function LayoutWrapper(props) {
  var children = props.children,
      Component = props.component,
      Layout = props.layout,
      render = props.render,
      childrenProps = _objectWithoutProperties(props, ["children", "component", "layout", "render"]);

  invariant(children || Component || render, 'LayoutWrapper requires at least one of `children` or `component` or `render` props.');
  var ch = null;

  if (Component) {
    ch = React.createElement(Component, childrenProps);
  } else if (render || typeof children === 'function') {
    ch = (render || children)(childrenProps);
  } else if (children) {
    ch = children;
  }

  return Layout ? React.createElement(Layout, null, ch) : ch;
}

LayoutWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  component: PropTypes.elementType,
  layout: PropTypes.elementType,

  /** (props: Object) => Node */
  render: PropTypes.func
};
LayoutWrapper.defaultProps = {
  children: undefined,
  component: undefined,
  layout: undefined,
  render: undefined
};
export default LayoutWrapper;